import { Instagram, Facebook, Mail, Phone } from "lucide-react";
import { IMAGES } from "@/lib/images";
import { scrollToId } from "./Reveal";

const SOCIALS = [
  { Icon: Instagram, href: "https://www.instagram.com/beautinbraidacademy", label: "Instagram", testId: "footer-instagram" },
  { Icon: Facebook, href: "https://www.facebook.com/61566836034101", label: "Facebook", testId: "footer-facebook" },
  { Icon: Mail, href: "mailto:thebeautinbraidacademy@outlook.com", label: "Email", testId: "footer-email" },
  { Icon: Phone, href: "tel:+19892073665", label: "Phone", testId: "footer-phone" },
];

export const Footer = () => (
  <footer data-testid="footer" className="bg-wine-deep border-t border-gold/15 py-16">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="grid md:grid-cols-3 gap-10 items-start">
        <div>
          <img src={IMAGES.logoLight} alt="BNB Academy" className="h-14 w-auto" />
          <p className="text-cream/50 mt-5 max-w-xs leading-relaxed">
            Beauti N Braid Academy — training with purpose, growing with passion, creating futures.
          </p>
        </div>

        <div className="md:justify-self-center">
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold mb-4">Explore</div>
          <div className="flex flex-col gap-3">
            {[
              { l: "The Program", id: "curriculum" },
              { l: "Instructor", id: "instructor" },
              { l: "Enroll", id: "pricing" },
              { l: "FAQ", id: "faq" },
            ].map((x) => (
              <button
                key={x.id}
                onClick={() => scrollToId(x.id)}
                className="text-left text-cream/60 hover:text-gold transition-colors duration-300"
              >
                {x.l}
              </button>
            ))}
          </div>
        </div>

        <div className="md:justify-self-end">
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold mb-4">Connect</div>
          <div className="flex gap-3">
            {SOCIALS.map(({ Icon, href, label, testId }) => (
              <a
                key={testId}
                data-testid={testId}
                href={href}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                aria-label={label}
                className="flex h-11 w-11 items-center justify-center rounded-full border border-cream/15 text-cream/70 hover:border-gold hover:text-gold transition-colors duration-300"
              >
                <Icon className="h-5 w-5" />
              </a>
            ))}
          </div>
          <div className="mt-5 space-y-1.5 text-cream/50 text-sm">
            <a href="mailto:thebeautinbraidacademy@outlook.com" className="block hover:text-gold transition-colors duration-300">
              thebeautinbraidacademy@outlook.com
            </a>
            <a href="tel:+19892073665" className="block hover:text-gold transition-colors duration-300">
              989.207.3665
            </a>
          </div>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-cream/10 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.15em] text-cream/40">
        <span>© 2026 Beauti N Braid Academy. All rights reserved.</span>
        <span>Crowned™ Pro · Level 1 · Launching September 15</span>
      </div>
    </div>
  </footer>
);
